import apiClient from '../utils/apiClient';

export const orderStaffAuditAPI = {
  getEvents: async (params = {}) => {
    return await apiClient.get({
      url: '/order-staff-audit/events',
      params,
    });
  },
};
